import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PAY} from '@web/core/urls'
import {unsubscribeMessage, subscribeMessage, changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, PopupMessageReceiveParam, ThunkApi} from '../interfaces'
import {getBackUrl} from '../utils'

const PAY_LATER_OVERDUE_URL = `${PAY}/paylater/overdue`

const POPUP_KEY = 'PAY_LATER_OVERDUE'
const MESSAGE_KEY = 'point_paylater'

/**
 * 후불결제 연체 안내 페이지로 이동
 */
const navigateToPayLaterOverdue = createAsyncThunk<
    NavigationResult,
    (NavigationTypeSelectableParam & PopupMessageReceiveParam) | void,
    ThunkApi
>('navigateTo/payLaterOverdue', async (args) => {
    const {forceLocationChange = false, bridgeUrl = ''} = args ?? {}

    const shouldChangeLocation = forceLocationChange || isMobile

    if (shouldChangeLocation) {
        const url = qs.stringifyUrl({
            url: PAY_LATER_OVERDUE_URL,
            query: {
                from: 'pc-order',
                rurl: getBackUrl(),
            },
        })
        changeBrowserLocation({url, type: 'PUSH'})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    const popupUrl = qs.stringifyUrl({
        url: PAY_LATER_OVERDUE_URL,
        query: {
            from: 'pc-order',
        },
    })

    return new Promise<string | void>((resolve, reject) => {
        const resolveCallback = (data: {message: string}) => {
            if (data.message === 'done') {
                resolve(data.message)
            }
            resolve()
        }

        // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
        subscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})

        // popup만 오픈
        openPopup({
            key: POPUP_KEY,
            url: popupUrl,
            popupQuery: {
                rurl: `${bridgeUrl}/${MESSAGE_KEY}/done`,
            },
            title: '네이버 후불결제',
            size: {
                width: 500,
                height: 660,
            },
        })
            .then(() => resolve())
            .catch(reject)
            .finally(() => {
                // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                unsubscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})
            })
    })
})

export default navigateToPayLaterOverdue
